$(function() {
	SiteControl.init();
});
